import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { signup, login } from "../auth/auth";
import { useGoogleLogin } from "@react-oauth/google";
import { Google as GoogleIcon } from "@mui/icons-material";
import axios from "axios";
import config from "../config.json";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password).then((response) => {
      if (response.status === "error") {
        setAlert(response.message);
      }
    });

    setLoading(false);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    await signup(email, password).then((response) => {
      if (response.status === "error") {
        setAlert(response.message);
      }
    });

    setLoading(false);
  };

  const googleLogin = useGoogleLogin({
    select_account: true,
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      setLoading(true);
      const response = await axios.post(`${config.apiBaseUrl}/google-login`, {
        token: tokenResponse["access_token"],
      });
      if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token);
        window.location.href = "/";
      } else {
        setAlert("Error during Google login");
      }
      setLoading(false);
    },
  });

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Container maxWidth="xs">
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="rgba(255, 255, 255, 0.7)"
          zIndex={9999}
        >
          <CircularProgress size={100} />
        </Box>
      )}
      <Snackbar
        open={alert !== null}
        autoHideDuration={5000}
        onClose={() => setAlert(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setAlert(null)} severity="error">
          {alert}
        </Alert>
      </Snackbar>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        pointerEvents={loading ? "none" : "auto"}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Login
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            required
            disabled={loading}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            disabled={loading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            style={{ marginTop: "16px" }}
            disabled={loading}
          >
            Login
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default Login;
